import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2741 1.5H6.234C5.83318 1.5 5.50825 1.82493 5.50825 2.22575V5.62096C5.50825 5.81344 5.58472 5.99804 5.72082 6.13415L7.04428 7.4576C7.62131 7.22577 8.23878 7.12596 8.84994 7.1579C9.47158 6.468 10.3179 5.98236 11.2741 5.81714L11.2741 1.5Z"
        fill={colorValue}
      />
      <path
        d="M18.279 6.13411L16.9556 7.45769C16.379 7.22615 15.762 7.1264 15.1513 7.1582C14.5294 6.46791 13.6824 5.98202 12.7256 5.81695V1.5H17.7658C18.1666 1.5 18.4915 1.82493 18.4915 2.22575V5.62096C18.4915 5.81343 18.4151 5.99801 18.279 6.13411Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 7.02924C10.9259 7.02924 9.96062 7.49513 9.29518 8.23366C8.30225 8.18177 7.28994 8.5349 6.53018 9.29467C5.77049 10.0543 5.41735 11.0666 5.46914 12.0595C4.73053 12.7249 4.26465 13.6902 4.26465 14.7644C4.26465 15.8388 4.73046 16.8041 5.46903 17.4696C5.4172 18.4625 5.7704 19.4746 6.53009 20.2344C7.28983 20.9942 8.30206 21.3473 9.29498 21.2954C9.96047 22.0341 10.9259 22.5 12.0001 22.5C13.0743 22.5 14.0396 22.0343 14.7051 21.2957C15.698 21.3474 16.71 20.9942 17.4696 20.2346C18.2293 19.475 18.5824 18.463 18.5307 17.4702C19.2696 16.8048 19.7356 15.8392 19.7356 14.7646C19.7356 13.6904 19.2697 12.7249 18.531 12.0594C18.5828 11.0667 18.2295 10.0546 17.4699 9.29502C16.7103 8.53547 15.6982 8.18221 14.7054 8.23391C14.0399 7.49529 13.0744 7.02924 12.0001 7.02924ZM11.57 11.3719C11.7288 10.9902 12.2703 10.9902 12.4291 11.3719L13.1671 13.1463L15.0825 13.3001C15.4951 13.3331 15.6624 13.8477 15.348 14.1171L13.8887 15.3672L14.3343 17.2362C14.4303 17.6389 13.9926 17.9568 13.6396 17.7413L11.9996 16.7396L10.3595 17.7413C10.0065 17.9568 9.56876 17.6385 9.66482 17.2362L10.1104 15.3672L8.6511 14.1171C8.33671 13.8477 8.504 13.3331 8.91658 13.3001L10.832 13.1463L11.57 11.3719Z"
        fill={colorValue}
      />
    </svg>
  );
};
